var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 15.3332C3.94999 15.3332 0.666748 12.0499 0.666748 7.99984C0.666748 3.94975 3.94999 0.666504 8.00008 0.666504C12.0502 0.666504 15.3334 3.94975 15.3334 7.99984C15.3334 12.0499 12.0502 15.3332 8.00008 15.3332ZM8.00008 13.9998C11.3138 13.9998 14.0001 11.3135 14.0001 7.99984C14.0001 4.68613 11.3138 1.99984 8.00008 1.99984C4.68637 1.99984 2.00008 4.68613 2.00008 7.99984C2.00008 11.3135 4.68637 13.9998 8.00008 13.9998ZM10.1953 5.52843L6.66675 9.05703L5.13815 7.52843L4.19534 8.47124L6.66675 10.9426L11.1382 6.47124L10.1953 5.52843Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.baaebd52e7cf8b62d0c4b4e6151b6226.svg";
export { ForwardRef as ReactComponent };